import React from "react"
import PropTypes from "prop-types"
import {
  getEntityTypeMapping,
  formatRoute,
} from "../../helpers/sharedHelperFunctions"
import FacilityCard from "../FacilityCard"
import DepartmentCard from "../DepartmentCard"
import Loading from "../Loading"
import "./LandingPage.scss"
import { Link } from "react-router-dom"
import routes from "../../routes"
import ResourceBanner from "../ResourceBanner"
import { Container, Row, Col } from "reactstrap"
import BsrComplianceToggleWithStore from "../BsrComplianceToggle/BsrComplianceToggleWithStore"

const LandingPage = props => {
  const entityTypeMapping = getEntityTypeMapping(props.entityType)
  const uniqueFacilityNames = props.entities
    .map(entity => entity.facilityName)
    .filter((entity, index, list) => list.indexOf(entity) === index)

  if (!props.loading) {
    return (
      <div className="LandingPage">
        <ResourceBanner
          title={`Your ${entityTypeMapping.pluralDisplay}`}
          bsrCompliance={props.bsrCompliance}
        />
        <Container fluid>
          <BsrComplianceToggleWithStore />
          <Row className="cards">
            {props.entities.map(entity => {
              return (
                <Col className="card" key={entity.id}>
                  <Link
                    to={formatRoute(routes.overview, {
                      entityType: entityTypeMapping.singularRoute,
                      entityId: entity.id,
                    })}
                  >
                    {entityTypeMapping ===
                    getEntityTypeMapping("facilities") ? (
                      <FacilityCard
                        name={entity.name}
                        compliance={entity.compliance}
                        opportunities={entity.opportunities}
                        departmentCount={entity.departmentCount}
                        unitCount={entity.unitCount}
                      />
                    ) : (
                      <DepartmentCard
                        name={entity.name}
                        compliance={entity.compliance}
                        opportunities={entity.opportunities}
                        facilityName={
                          uniqueFacilityNames.length > 1
                            ? entity.facilityName
                            : null
                        }
                        staffCount={entity.staffCount}
                      />
                    )}
                  </Link>
                </Col>
              )
            })}
            {Array(6)
              .fill()
              .map((_, i) => (
                <Col key={i} className="card" />
              )) /* need a bunch of empty cards to left-align bottom row */}
          </Row>
        </Container>
      </div>
    )
  } else {
    return (
      <div className="LandingPage loading">
        <Loading />
      </div>
    )
  }
}

LandingPage.propTypes = {
  entityType: PropTypes.oneOf(["facilities", "departments"]).isRequired,
  entities: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      compliance: PropTypes.number,
      opportunities: PropTypes.number.isRequired,
      departmentCount: PropTypes.number, // for facilities
      unitCount: PropTypes.number, // for facilities
      facilityName: PropTypes.string, // for departments
      staffCount: PropTypes.number, // for departments
    })
  ),
  loading: PropTypes.bool,
}

LandingPage.defaultProps = {
  entities: [],
}

export default LandingPage
